import {
  validDocNumber,
  validCIF,
  validContactMedia,
  validPrevContactMedia,
} from '@/utils/validators';
import { VALIDATE_SMS_ERRORS_IN_FORM } from './constant';

export const DOC_NUMBER = {
  NAME: 'docNumber',
  ID: 'docNumber',
  LABEL: 'NIF',
  RULES: {
    REQUIRED: 'Campo obligatorio',
    VALIDATE: {
      DOC_NUMBER_FORMAT: {
        checkFunc: validDocNumber,
        message: 'El NIF no es válido. Revisa que el número y la letra final son correctos.',
      },
    },
  },
};

export const CIF = {
   NAME: 'cif',
  ID: 'cif',
  LABEL: 'CIF / NIE o Pasaporte',
  RULES: {
    REQUIRED: 'Campo obligatorio',
    VALIDATE: {
      DOC_NUMBER_FORMAT: {
        checkFunc: validCIF,
        message: 'El formato introducido no es válido',
      },
    },
  },
}
export const CONTACT_MEDIA = {
  NAME: 'phone',
  ID: 'phone',
  LABEL: 'Móvil o email',
  RULES: {
    REQUIRED: 'Campo obligatorio',
    VALIDATE: {
      CONTACT_MEDIA_FORMAT: {
        checkFunc: validContactMedia,
        message:
          'El medio de contacto no es válido. Por favor, utiliza uno diferente.',
      },
      PREV_CONTACT_MEDIA: {
        checkFunc: validPrevContactMedia,
        message: VALIDATE_SMS_ERRORS_IN_FORM[461],
      },
    },
  },
};
export const NEW_CONTACT_MEDIA = {
  NAME: 'newContactMedia',
  ID: 'newContactMedia',
  LABEL: 'Móvil o email',
  RULES: {
    REQUIRED: 'Campo obligatorio',
    VALIDATE: {
      CONTACT_MEDIA_FORMAT: {
        checkFunc: validContactMedia,
        message:
          'El medio de contacto no es válido. Por favor, utiliza uno diferente.',
      },
      PREV_CONTACT_MEDIA: {
        checkFunc: validPrevContactMedia,
        message: VALIDATE_SMS_ERRORS_IN_FORM[461],
      },
    },
  },
};

export const STEPS = {
  NEW_ACCOUNT: 'NEW_ACCOUNT',
  RECOVERY_ACCOUNT: 'RECOVERY_ACCOUNT',
  CONTACT_MEDIA: 'CONTACT_MEDIA',
  NEW_CONTACT_MEDIA: 'NEW_CONTACT_MEDIA',
};
export const STEPS_TAGGING_TEXT = {
  [STEPS.NEW_ACCOUNT]: 'continuar-paso1',
  [STEPS.RECOVERY_ACCOUNT]: 'continuar-paso1',
  [STEPS.CONTACT_MEDIA]: 'continuar-paso2',
  [STEPS.NEW_CONTACT_MEDIA]: 'continuar-paso3',
};
export const STEPS_TEXTS = {
  [STEPS.NEW_ACCOUNT]: [
    'Crea tu cuenta para gestionar tus servicios.',
    'Por favor, introduce tu NIF completo, sin espacios ni guiones, incluyendo la letra.',
  ],
  [STEPS.RECOVERY_ACCOUNT]: [
    'Por favor, introduce tu NIF completo, sin espacios ni guiones, incluyendo la letra.',
  ],
  [STEPS.CONTACT_MEDIA]: [
    'Introduce un medio de contacto para recibir un código de seguridad.',
    'Puedes usar tu móvil o email de contacto con nosotros, o una de tus líneas móviles con Movistar.',
  ],
  [STEPS.NEW_CONTACT_MEDIA]: [
    'Puedes añadir ahora un medio de contacto nuevo con Movistar. Por seguridad, te ayudaremos a verificar tu identidad en un sencillo proceso de dos pasos.',
  ],
};
export const STEP_TITLE = {
  [STEPS.NEW_ACCOUNT]: 'Crear cuenta',
  [STEPS.RECOVERY_ACCOUNT]: 'Restablecer contraseña',
  [STEPS.CONTACT_MEDIA]: 'Medio de contacto',
  [STEPS.NEW_CONTACT_MEDIA]: 'Añadir nuevo medio',
};
